// src/context/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

export const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

const ACCOUNT_KEY = 'selectedAccount';

export const AppContextProvider = ({ children }) => {
  const [fullMenu, setFullMenu] = useState(false);
  const [username, setUserName] = useState('');
  // running portfolio process
  const [isProcessRunning, setIsProcessRunning] = useState(false);

  // selected account — persisted in sessionStorage
  const [selectedAccount, setSelectedAccountState] = useState(() => {
    try {
      const stored = sessionStorage.getItem(ACCOUNT_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const setSelectedAccount = (account) => {
    if (account) {
      sessionStorage.setItem(ACCOUNT_KEY, JSON.stringify(account));
    } else {
      sessionStorage.removeItem(ACCOUNT_KEY);
    }
    setSelectedAccountState(account);
  };

  const toggHeader = () => {
    setFullMenu((value) => !value)
  };

  return (
    <AppContext.Provider value={{ fullMenu, toggHeader, isProcessRunning, setIsProcessRunning, selectedAccount, setSelectedAccount }}>
      {children}
    </AppContext.Provider>
  );
};
